import React, { Component } from 'react';
import classes from './Autocomplete.module.css';
import Spinner from '../Spinner/Spinner';
import Input from '../Input/Input';
import strings from '../../../assets/localization/index';
import { isFirefox, isAndroid, isChrome } from 'react-device-detect';
import debounce from 'lodash/debounce';
const DEBOUNCE_TIME = 500;

export default class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.timer = 0;
    this.state = {
      searchTerm: '',
      suggestions: [],
      showList: false,
      isSelected: false,
      selectedValue: '',
    };
    this.input_ref;
  }

  componentDidMount() {
    // console.log('AUTOCOMPONENT DID MOUNT:::', this.props);
    if (this.props.location !== '') {
      this.setState({ searchTerm: this.props.location, isSelected: true });
    }
  }

  componentDidUpdate(prevProps) {
    // console.log('AUTOCOMPLETE DID UPDATE:::', this.props, prevProps);
    if (
      this.props.searchLocation.status === 'success' &&
      this.props.searchLocation.status !== prevProps.searchLocation.status
    ) {
      this.setState({
        suggestions: this.props.searchLocation.response.data,
        showList: true,
      });
    } else if (this.props.searchLocation.status === 'fail') {
      this.setState({ showList: false });
    }

    if (this.props.location && this.props.location !== prevProps.location) {
      this.setState({
        searchTerm: this.props.location,
        selectedValue: this.props.location,
        showList: false,
        isSelected: true,
      });
    }
  }

  _fetchData = async (searchTerm) => {
    this.props.nbsApiSearchLocation({ q: searchTerm });
  };

  _onChangeText = (e) => {
    // console.log('ENTERING TEXT>>>>>>>>', e.target.value);
    const {
      target: { value },
    } = e;

    if (this.state.isSelected === true) {
      this.setState({ searchTerm: value, isSelected: false });
    } else {
      this.setState({ searchTerm: value });
    }
    if (value.length > 2) {
      this._debounceApi(value);
    } else {
      this.props.setLocation('');
    }
  };

  _debounceApi = debounce(this._fetchData, DEBOUNCE_TIME);

  _resetSearch = () => {
    // console.log('RESET', this.state);
    this.setState({ isSelected: false, searchTerm: '', showList: false });
    this.props.setLocation('', 0, 0);
  };

  _renderRow = (data, i) => {
    return (
      <div
        onClick={this._setValue.bind(this, data)}
        key={i}
        className={classes.ListItemWrapper}
      >
        <div className={classes.MapMarker}>
          <svg className={classes.MapMarkerIcon}>
            <use xlinkHref='/sprites.svg#icon-location-pin' />
          </svg>
        </div>
        <div className={classes.ListItemText}>{data.place}</div>
      </div>
    );
  };

  _setValue = (data) => {
    // console.log('CLICK ON LIST ITEM DATA:', data);
    const { place, lat, countryCode } = data;
    this.setState({
      searchTerm: place,
      selectedValue: place,
      isSelected: true,
      showList: false,
    });
    this.props.setLocation(place, lat, data.lon || data.lng, countryCode);
  };

  _renderRightImage = () => {
    if (this.props.searchLocation.isFetching === true) {
      return <Spinner size='Verysmall' />;
    } else {
      if (this.state.isSelected === true) {
        return (
          <svg
            className={
              this.props.fromWhere === 'editProfile'
                ? [classes.RightImageCheckMark, classes.GrayChevron].join(' ')
                : classes.RightImageCheckMark
            }
          >
            <use
              xlinkHref={
                this.props.fromWhere === 'editProfile'
                  ? '/sprites.svg#icon-arrow-right'
                  : '/sprites.svg#icon-check-inverted'
              }
            />
          </svg>
        );
      } else {
        return (
          <svg onClick={this._resetSearch} className={classes.RightImageCancel}>
            <use xlinkHref='/sprites.svg#icon-cross-in-circle-filled' />
          </svg>
        );
      }
    }
  };

  _renderList = () => {
    if (this.state.showList === true) {
      const { suggestions } = this.state;
      const listStyle = {};
      if (isFirefox) {
        listStyle.marginTop = 0;
      } else if (
        isAndroid &&
        isChrome &&
        this.props.fromWhere &&
        this.props.fromWhere === 'missingLocation'
      ) {
        listStyle.marginTop = '2rem';
      } else {
        // listStyle.marginTop = '-0.833rem';
      }
      return (
        <div className={classes.ListWrapper} style={listStyle}>
          {suggestions.map(this._renderRow)}
        </div>
      );
    } else {
      return <div />;
    }
  };

  _onBlur = () => {
    setTimeout(() => {
      // console.log('ON BLUR!!!', this.state, e);
      if (this.state.selectedValue !== '' && this.state.showList) {
        this.setState({
          showList: false,
          searchTerm: this.state.selectedValue,
          isSelected: true,
        });
      }
      if (this.props.onBlur && typeof this.props.onBlur === 'function') {
        this.props.onBlur();
      }
    }, 300);
  };

  render() {
    // console.log('AUTOCOMPLETE RENDER:', this.props, this.state);
    const inputStyle = {
      paddingLeft: this.props.fromWhere === 'editProfile' ? 0 : '2pt',
      paddingRight: this.props.fromWhere === 'editProfile' ? 0 : '2pt',
    };
    return (
      <div className={classes.Autocomplete}>
        <div className={classes.InputWrapper} style={inputStyle}>
          <div className={classes.InputHolder}>
            <Input
              setRef={this.props.setRef || 'input'}
              noOutline={this.props.noOutline}
              onChange={this._onChangeText}
              value={this.state.searchTerm}
              type='text'
              onFocus={this.props.onFocus}
              onBlur={this._onBlur}
              placeholder={this.props.placeholder || strings.EnterYourLocation}
              label={null}
              required
              maxLength={128}
            />
            <div
              className={classes.RightImageWrapper}
              style={{
                right:
                  this.props.fromWhere === 'editProfile' ? '0.625rem' : '4.4pt',
              }}
            >
              {this._renderRightImage()}
            </div>
          </div>
        </div>
        {this._renderList()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/AutocompleteInner/Autocomplete.js